<div class="workorder-card" [ngClass]="{ active: flag }">
  <div class="botton" [ngClass]="statusMap[data.status].class"></div>
  <div class="content">
    <div class="item1">
      <app-image [fileid]="data.bus_seat?.bus?.platform.icon"></app-image>
      <span>
        <ng-container
          *ngIf="
            data.bus_seat?.bus?.platform.name !== 'ChatGPT镜像版' &&
            data.bus_seat?.bus?.platform.name !== '爆米花' &&
            data.bus_seat?.bus?.platform.name !== 'Midjourney镜像版' &&
            data.bus_seat?.bus?.platform.name !== 'Grok镜像版'
          "
        >
          {{ data.bus_seat?.bus?.bus_account?.username }}</ng-container
        ></span
      >
    </div>
    <div class="item2">
      <div
        class="left"
        *ngIf="statusMap[data.status]"
        [ngClass]="statusMap[data.status].class"
      >
        <div class="status-main">
          <span class="small-dot"></span>
          <span> {{ statusMap[data.status].text }}</span>
        </div>

        <div class="status-desc">
          {{ statusMap[data.status].desc }}
        </div>
      </div>
      <mat-icon style="margin-left: 35px"> keyboard_arrow_right </mat-icon>
    </div>
    <div class="item3">
      #{{ data.bus_seat?.bus_id }} {{ data?.problem_platform?.problem }}
    </div>
  </div>
</div>
